import {loginSelectors} from 'features/login/redux';
import React from 'react';
import {useSelector} from 'react-redux';

export const useTitle = () => {
   const machineName = useSelector(loginSelectors.machineName);
   React.useEffect(() => {
      if (machineName) {
         document.title = `Diplomat MFT - ${machineName}`;
      }
   }, [machineName]);
};
